/* eslint-disable max-len */
import { Card, Col, Image, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import Footer from 'components/base/Footer';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import AppMenu from 'components/molecules/AppMenu';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import useProfily from 'hooks/useProfily';

import routePathEnum from 'enums/routePathEnum';

import next from 'styles/images/next.svg';

const cardTitlestyle = {
    marginTop: 5,
    marginBottom: 0,
    fontWeight: 700,
    fontSize: 20
};

const RozcestnikLogin: React.FC = () => {
    const { language } = useContext(Context);
    const { navigateWorkaround } = useNavigateWorkaround();
    const [showNUoptions, setShowNUoption] = useState<boolean>(false);
    const { setLevel } = useProfily();
    const isDLT = window.location.href.includes(routePathEnum.LOGIN_ROZCESTNIKDLT);

    useEffect(() => {
        setLevel('prevPath', window.location.href);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <AppMenu />
            <Row
                style={{
                    backgroundColor: '#f9f9f9',
                    paddingBottom: 40,
                    minHeight: '70vh'
                }}
            >
                <Col span={4} />
                <Col span={16}>
                    <Row>
                        <Col
                            span={24}
                            style={{
                                marginTop: 40
                            }}
                        />
                    </Row>
                    <Row gutter={16} justify="start">
                        {showNUoptions ? (
                            <>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} className="dashboard-card-col-card">
                                    <AnchorComponent
                                        onClick={() => {
                                            window.location.assign(
                                                window.location.hostname.includes('test')
                                                    ? 'https://test.cdcp.cz/nezarazeny-ucet-bankid/'
                                                    : 'https://www.cdcp.cz/nezarazeny-ucet-bankid/'
                                            );
                                        }}
                                        className={'hover-border'}
                                    >
                                        <Card
                                            title={
                                                <h4 style={cardTitlestyle}>
                                                    <TranslateText>ROZCESTNIK_LOGIN_NU</TranslateText>
                                                </h4>
                                            }
                                            extra={
                                                <ButtonComponent
                                                    id={'dashBoardCardButton'}
                                                    icon={
                                                        <Image
                                                            alt="next icon"
                                                            src={next}
                                                            preview={false}
                                                            height="20px"
                                                            width="10px"
                                                        />
                                                    }
                                                    buttontext=""
                                                    type="text"
                                                    style={{
                                                        marginTop: '0.9em'
                                                    }}
                                                />
                                            }
                                            style={{
                                                height: '100%'
                                            }}
                                            className="dash-card"
                                        >
                                            <TranslateText>ROZCESTNIK_LOGIN_NU_TEXT</TranslateText>
                                        </Card>
                                    </AnchorComponent>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} className="dashboard-card-col-card">
                                    <AnchorComponent
                                        onClick={() => {
                                            window.location.assign(
                                                window.location.hostname.includes('test')
                                                    ? 'https://test.cdcp.cz/nezarazeny-ucet-zjisteni/'
                                                    : 'https://www.cdcp.cz/nezarazeny-ucet-zjisteni/'
                                            );
                                        }}
                                        className={'hover-border'}
                                    >
                                        <Card
                                            title={
                                                <h4 style={cardTitlestyle}>
                                                    <TranslateText>ROZCESTNIK_LOGIN_MU</TranslateText>
                                                </h4>
                                            }
                                            extra={
                                                <ButtonComponent
                                                    id={'dashBoardCardButton'}
                                                    icon={
                                                        <Image
                                                            alt="next icon"
                                                            src={next}
                                                            preview={false}
                                                            height="20px"
                                                            width="10px"
                                                        />
                                                    }
                                                    buttontext=""
                                                    type="text"
                                                    style={{
                                                        marginTop: '0.9em'
                                                    }}
                                                />
                                            }
                                            style={{
                                                height: '100%'
                                            }}
                                            className="dash-card"
                                        >
                                            <TranslateText>ROZCESTNIK_LOGIN_MU_TEXT</TranslateText>
                                        </Card>
                                    </AnchorComponent>
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} className="dashboard-card-col-card">
                                    <AnchorComponent
                                        onClick={() => {
                                            window.location.assign(
                                                window.location.hostname.includes('test')
                                                    ? 'https://test.cdcp.cz/nezarazeny-ucet-zmena/'
                                                    : 'https://www.cdcp.cz/nezarazeny-ucet-zmena/'
                                            );
                                        }}
                                        className={'hover-border'}
                                    >
                                        <Card
                                            title={
                                                <h4 style={cardTitlestyle}>
                                                    <TranslateText>ROZCESTNIK_LOGIN_NUE</TranslateText>
                                                </h4>
                                            }
                                            extra={
                                                <ButtonComponent
                                                    id={'dashBoardCardButton'}
                                                    icon={
                                                        <Image
                                                            alt="next icon"
                                                            src={next}
                                                            preview={false}
                                                            height="20px"
                                                            width="10px"
                                                        />
                                                    }
                                                    buttontext=""
                                                    type="text"
                                                    style={{
                                                        marginTop: '0.9em'
                                                    }}
                                                />
                                            }
                                            style={{
                                                height: '100%'
                                            }}
                                            className="dash-card"
                                        >
                                            <TranslateText>ROZCESTNIK_LOGIN_NUE_TEXT</TranslateText>
                                        </Card>
                                    </AnchorComponent>
                                </Col>
                                <Row
                                    style={{
                                        width: '100%',
                                        marginTop: 16
                                    }}
                                >
                                    <ButtonComponent
                                        buttontext="ZPET"
                                        onClick={() => setShowNUoption(false)}
                                        type="default"
                                    />
                                </Row>
                            </>
                        ) : (
                            <>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12} className="dashboard-card-col-card">
                                    <AnchorComponent
                                        onClick={() => {
                                            navigateWorkaround(routePathEnum.EMITENT_LOGIN_MUJDEP);
                                        }}
                                        className={'hover-border'}
                                    >
                                        <Card
                                            title={
                                                <h4 style={cardTitlestyle}>
                                                    <TranslateText>ROZCESTNIK_LOGIN_EMITENT</TranslateText>
                                                </h4>
                                            }
                                            extra={
                                                <ButtonComponent
                                                    id={'dashBoardCardButton'}
                                                    icon={
                                                        <Image
                                                            alt="next icon"
                                                            src={next}
                                                            preview={false}
                                                            height="20px"
                                                            width="10px"
                                                        />
                                                    }
                                                    buttontext=""
                                                    type="text"
                                                    style={{
                                                        marginTop: '0.9em'
                                                    }}
                                                />
                                            }
                                            style={{
                                                height: '100%'
                                            }}
                                            className="dash-card"
                                        >
                                            <li>
                                                <TranslateText>AMLZ</TranslateText>
                                                {' / '}
                                                <TranslateText>ISIN</TranslateText>
                                                {' / '}
                                                <TranslateText>PRIMARNI_UPIS</TranslateText>
                                                {' / '}
                                                <TranslateText>VYPIS_Z_EMISE</TranslateText>
                                                {' / '}
                                                <TranslateText>ROZCESTNIK_LOGIN_EMITENT_SUB</TranslateText>
                                            </li>
                                        </Card>
                                    </AnchorComponent>
                                </Col>
                                {isDLT && (
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="dashboard-card-col-card">
                                        <AnchorComponent
                                            onClick={() => {
                                                window.location.assign(
                                                    !window.location.hostname.includes('test')
                                                        ? `https://dlt.cdcp.cz/#/?lang=${language === 'cz' ? 'cs' : 'en'}`
                                                        : `https://test-dlt.cdcp.cz/#/?lang=${language === 'cz' ? 'cs' : 'en'}`
                                                );
                                            }}
                                            className={'hover-border'}
                                        >
                                            <Card
                                                title={
                                                    <h4 style={cardTitlestyle}>
                                                        <TranslateText>ROZCESTNIK_LOGIN_DLT</TranslateText>
                                                    </h4>
                                                }
                                                extra={
                                                    <ButtonComponent
                                                        id={'dashBoardCardButton'}
                                                        icon={
                                                            <Image
                                                                alt="next icon"
                                                                src={next}
                                                                preview={false}
                                                                height="20px"
                                                                width="10px"
                                                            />
                                                        }
                                                        buttontext=""
                                                        type="text"
                                                        style={{
                                                            marginTop: '0.9em'
                                                        }}
                                                    />
                                                }
                                                style={{
                                                    height: '100%'
                                                }}
                                                className="dash-card"
                                            >
                                                <li>
                                                    <TranslateText>ZALOZENI_UCTU</TranslateText>
                                                    {' / '}
                                                    <TranslateText>VSTUP_UCET</TranslateText>
                                                </li>
                                            </Card>
                                        </AnchorComponent>
                                    </Col>
                                )}
                                {!isDLT && (
                                    <>
                                        <Col
                                            xs={24}
                                            sm={24}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            className="dashboard-card-col-card"
                                        >
                                            <AnchorComponent
                                                onClick={() => {
                                                    navigateWorkaround(routePathEnum.LEI_LOGIN_MUJDEP);
                                                }}
                                                className={'hover-border'}
                                            >
                                                <Card
                                                    title={
                                                        <h4 style={cardTitlestyle}>
                                                            <TranslateText>ROZCESTNIK_LOGIN_LEI</TranslateText>
                                                        </h4>
                                                    }
                                                    extra={
                                                        <ButtonComponent
                                                            id={'dashBoardCardButton'}
                                                            icon={
                                                                <Image
                                                                    alt="next icon"
                                                                    src={next}
                                                                    preview={false}
                                                                    height="20px"
                                                                    width="10px"
                                                                />
                                                            }
                                                            buttontext=""
                                                            type="text"
                                                            style={{
                                                                marginTop: '0.9em'
                                                            }}
                                                        />
                                                    }
                                                    style={{
                                                        height: '100%'
                                                    }}
                                                    className="dash-card"
                                                >
                                                    <li>
                                                        <TranslateText>ROZCESTNIK_LOGIN_LEI_SUB1</TranslateText>
                                                        {' / '}
                                                        <TranslateText>ROZCESTNIK_LOGIN_LEI_SUB2</TranslateText>
                                                        {' / '}
                                                        <TranslateText>ROZCESTNIK_LOGIN_LEI_SUB3</TranslateText>
                                                        {' / '}
                                                        <TranslateText>ROZCESTNIK_LOGIN_LEI_SUB4</TranslateText>
                                                    </li>
                                                </Card>
                                            </AnchorComponent>
                                        </Col>
                                        <Col
                                            xs={24}
                                            sm={24}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            className="dashboard-card-col-card"
                                        >
                                            <AnchorComponent
                                                onClick={() => {
                                                    setShowNUoption(true);
                                                }}
                                                className={'hover-border'}
                                            >
                                                <Card
                                                    title={
                                                        <h4 style={cardTitlestyle}>
                                                            <TranslateText>MAJITEL_NU</TranslateText>
                                                        </h4>
                                                    }
                                                    extra={
                                                        <ButtonComponent
                                                            id={'dashBoardCardButton'}
                                                            icon={
                                                                <Image
                                                                    alt="next icon"
                                                                    src={next}
                                                                    preview={false}
                                                                    height="20px"
                                                                    width="10px"
                                                                />
                                                            }
                                                            buttontext=""
                                                            type="text"
                                                            style={{
                                                                marginTop: '0.9em'
                                                            }}
                                                        />
                                                    }
                                                    style={{
                                                        height: '100%'
                                                    }}
                                                    className="dash-card"
                                                >
                                                    <li>
                                                        <TranslateText>VYPIS_Z_UCTU_SIMPLE</TranslateText>
                                                        {' / '}
                                                        <TranslateText>ZAPIS_ZMENY_UDAJU</TranslateText>
                                                        {' / '}
                                                        <TranslateText>ZJISTENI_UCTU</TranslateText>
                                                    </li>
                                                </Card>
                                            </AnchorComponent>
                                        </Col>
                                        <Col
                                            xs={24}
                                            sm={24}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            className="dashboard-card-col-card"
                                        >
                                            <AnchorComponent
                                                onClick={() => {
                                                    navigateWorkaround(routePathEnum.SRD_LOGIN_MUJDEP);
                                                }}
                                                className={'hover-border'}
                                            >
                                                <Card
                                                    title={
                                                        <h4 style={cardTitlestyle}>
                                                            <TranslateText>
                                                                ROZCESTNIK_LOGIN_SRD_TITLE_SHORT
                                                            </TranslateText>
                                                        </h4>
                                                    }
                                                    extra={
                                                        <ButtonComponent
                                                            id={'dashBoardCardButton'}
                                                            icon={
                                                                <Image
                                                                    alt="next icon"
                                                                    src={next}
                                                                    preview={false}
                                                                    height="20px"
                                                                    width="10px"
                                                                />
                                                            }
                                                            buttontext=""
                                                            type="text"
                                                            style={{
                                                                marginTop: '0.9em'
                                                            }}
                                                        />
                                                    }
                                                    style={{
                                                        height: '100%'
                                                    }}
                                                    className="dash-card"
                                                >
                                                    <li>
                                                        <TranslateText>MAJITEL_UCTU</TranslateText>
                                                        {' / '}
                                                        <TranslateText>SPRAVCE_UCTU</TranslateText>
                                                        {' / '}
                                                        <TranslateText>UCASTNIK_CDCP</TranslateText>
                                                    </li>
                                                </Card>
                                            </AnchorComponent>
                                        </Col>
                                        <Col
                                            xs={24}
                                            sm={24}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            className="dashboard-card-col-card"
                                        >
                                            <AnchorComponent
                                                onClick={() => {
                                                    navigateWorkaround(routePathEnum.STATNISPRAVA_LOGIN_MUJDEP);
                                                }}
                                                className={'hover-border'}
                                            >
                                                <Card
                                                    title={
                                                        <h4 style={cardTitlestyle}>
                                                            <TranslateText>STATNI_SPRAVA</TranslateText>
                                                        </h4>
                                                    }
                                                    extra={
                                                        <ButtonComponent
                                                            id={'dashBoardCardButton'}
                                                            icon={
                                                                <Image
                                                                    alt="next icon"
                                                                    src={next}
                                                                    preview={false}
                                                                    height="20px"
                                                                    width="10px"
                                                                />
                                                            }
                                                            buttontext=""
                                                            type="text"
                                                            style={{
                                                                marginTop: '0.9em'
                                                            }}
                                                        />
                                                    }
                                                    style={{
                                                        height: '100%'
                                                    }}
                                                    className="dash-card"
                                                >
                                                    <li>
                                                        <TranslateText>STATNI_SPRAVA_1</TranslateText>
                                                        {' / '}
                                                        <TranslateText>STATNI_SPRAVA_2</TranslateText>
                                                        {' / '}
                                                        <TranslateText>STATNI_SPRAVA_3</TranslateText>
                                                        {' / '}
                                                        <TranslateText>STATNI_SPRAVA_4</TranslateText>
                                                        {' / '}
                                                        <TranslateText>STATNI_SPRAVA_5</TranslateText>
                                                        {' / '}
                                                        <TranslateText>STATNI_SPRAVA_6</TranslateText>
                                                    </li>
                                                </Card>
                                            </AnchorComponent>
                                        </Col>
                                        <Col
                                            xs={24}
                                            sm={24}
                                            md={12}
                                            lg={12}
                                            xl={12}
                                            className="dashboard-card-col-card"
                                        >
                                            <AnchorComponent
                                                onClick={() => {
                                                    navigateWorkaround(routePathEnum.LOGIN_JINA_OSOBA);
                                                }}
                                                className={'hover-border'}
                                            >
                                                <Card
                                                    title={
                                                        <h4 style={cardTitlestyle}>
                                                            <TranslateText>JINA_OSOBA</TranslateText>
                                                        </h4>
                                                    }
                                                    extra={
                                                        <ButtonComponent
                                                            id={'dashBoardCardButton'}
                                                            icon={
                                                                <Image
                                                                    alt="next icon"
                                                                    src={next}
                                                                    preview={false}
                                                                    height="20px"
                                                                    width="10px"
                                                                />
                                                            }
                                                            buttontext=""
                                                            type="text"
                                                            style={{
                                                                marginTop: '0.9em'
                                                            }}
                                                        />
                                                    }
                                                    style={{
                                                        height: '100%'
                                                    }}
                                                    className="dash-card"
                                                >
                                                    <TranslateText>JINA_OSOBA_TEXT</TranslateText>
                                                </Card>
                                            </AnchorComponent>
                                        </Col>
                                    </>
                                )}
                            </>
                        )}
                    </Row>
                </Col>
                <Col span={4} />
            </Row>
            <Footer />
        </>
    );
};

export default RozcestnikLogin;
